import { Add as AddIcon } from '@mui/icons-material';
import { IconButton, Tooltip, Button } from '@mui/material';
import { EntityType } from '@nohara-dxdev/mt-common';
import { permission } from '@nohara-dxdev/oidc-core';
import { OidcProtectedComponent, useScopeIds } from '@nohara-dxdev/react-oidc';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CreateTaskDialog } from './create-task-dialog';

const createTaskPermissions = [permission.task.create];

export interface CreateTaskButtonProps {
  entityId: string;
  entityType: EntityType;
  showName?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
}

export const CreateTaskButton = ({
  entityId,
  entityType,
  showName = false,
  variant = 'contained',
  size = 'small',
}: CreateTaskButtonProps) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const scopeIds = useScopeIds();

  const subject = useMemo(
    () => ({
      ...scopeIds,
      entityId,
      entityType,
    }),
    [scopeIds, entityId, entityType],
  );

  return (
    <OidcProtectedComponent requireAll={createTaskPermissions} subject={subject}>
      {showName ? (
        <Button
          color="primary"
          onClick={() => {
            setDialogOpen(true);
          }}
          size={size}
          variant={variant}
          startIcon={<AddIcon />}
        >
          {t('tasks.create.button')}
        </Button>
      ) : (
        <Tooltip title={t('tasks.create.button')}>
          <IconButton
            color="primary"
            onClick={() => {
              setDialogOpen(true);
            }}
            size={size}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      )}

      <CreateTaskDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        entityId={entityId}
        entityType={entityType}
      />
    </OidcProtectedComponent>
  );
};
